import React from 'react';

export const LoadingSpinner: React.FC = () => {
  return (
    <div data-testid="loading-spinner" className="flex items-center justify-center min-h-screen bg-gray-100">
      <div className="relative">
        <div className="w-12 h-12 rounded-full absolute border-4 border-solid border-gray-200"></div>
        <div className="w-12 h-12 rounded-full animate-spin absolute border-4 border-solid border-blue-600 border-t-transparent"></div>
      </div>
    </div>
  );
};
